// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AdminType from "../types/admin/AdminType.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  return DeccoUtils$Catalyst.resolveResult(AdminType.t_decode(json), "AdminDetailsStateMapper.re");
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
